<template>
  <v-container
    class="
      text-caption
      text-sm-subtitle-1
      text-md-subtitle-1
      text-lg-subtitle-1
      text-xl-subtitle-1
    "
  >
    <v-form ref="form">
      <v-row>
        <v-col cols="12" xl="6" lg="6" md="6">
          <v-row class="">
            <v-col class="pb-2">
              <span class="primary--text font-weight-bold">{{
                translations.label_project_information
              }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0">
              <v-text-field
                solo
                :label="translations.label_name"
                outlined
                :rules="validation(translations.field_required)"
                v-model="form.name"
                background-color="white"
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0">
              <v-autocomplete
                solo
                :label="translations.label_select_project_type"
                outlined
                :rules="validation(translations.field_required)"
                :items="projectTypes"
                v-model="form.projectType"
                background-color="white"
                dense
                return-object
                @change="resetData"
                :disabled="isUpdatingProject && statusProjectToUpdate != 'NEW'"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0">
              <v-textarea
                solo
                :label="translations.label_description"
                outlined
                v-model="form.description"
                background-color="white"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row
            v-if="
              form.projectType &&
                (form.projectType.value == 'MISS_TEST' ||
                  form.projectType.value == 'PRODUCT_SETUP')
            "
          >
            <v-col class="py-0">
              <v-autocomplete
                :label="translations.label_select_variant"
                :items="
                  form.projectType.value == 'PRODUCT_SETUP'
                    ? mis_test_variant_setup
                    : miss_test_variants
                "
                v-model="form.variant"
                dense
                outlined
                :rules="validation(translations.field_required)"
                @change="changeVariant"
                return-object
                background-color="white"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          xl="6"
          lg="6"
          md="6"
          :class="
            this.$vuetify.breakpoint.name != 'xl' &&
            this.$vuetify.breakpoint.name != 'lg' &&
            this.$vuetify.breakpoint.name != 'md'
              ? 'mt-0 pt-0'
              : ''
          "
          v-if="form.projectType"
        >
          <v-row class="">
            <v-col class="pb-2">
              <span class="primary--text font-weight-bold">
                <div v-if="form.projectType.value == 'PRODUCT_SETUP'">
                  {{ translations.label_agricultural_units }}
                </div>
                <div v-else>
                  {{ translations.label_contrast_a }}
                </div>
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0">
              <v-text-field
                solo
                :label="translations.label_name"
                outlined
                :rules="validation(translations.field_required)"
                v-model="form.mainContrast.name"
                background-color="white"
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0">
              <v-autocomplete
                solo
                :label="translations.label_select_irrigation_unit"
                outlined
                v-model="tempCropZoneMain"
                :search-input.sync="searchMain"
                item-text="cropZoneName"
                clearable
                hide-no-data
                :items="mainContrastCropZones"
                :loading="isLoadingMainCropZones"
                background-color="white"
                dense
                @change="addMainCropZone"
                return-object
                ref="mainCrop"
                :rules="[mainValidation]"
                :disabled="isUpdatingProject && statusProjectToUpdate != 'NEW'"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-if="statusProjectToUpdate == 'NEW'">
              <v-chip
                close
                @click:close="removeCropZoneA(index)"
                v-for="(area, index) of form.mainContrast.cropZones"
                :key="index"
              >
                <v-icon left color="primary"> mdi-sprout </v-icon>
                {{ area.cropZoneName }}
              </v-chip>
            </v-col>
            <v-col v-else>
              <v-chip
                v-for="(area, index) of form.mainContrast.cropZones"
                :key="index"
              >
                <v-icon left color="primary"> mdi-sprout </v-icon>
                {{ area.cropZoneName }}
              </v-chip>
            </v-col>
          </v-row>
          <div
            v-if="
              form.projectType.value != 'MISS_TEST' &&
              form.projectType.value != 'PRODUCT_SETUP'
                ? true
                : form.variant && form.variant.value == 'CONTRAST'
                ? true
                : false
            "
          >
            <v-row class="">
              <v-col class="pb-2">
                <span class="primary--text font-weight-bold">
                  <div v-if="form.projectType.value == 'PRODUCT_SETUP'">
                    {{ translations.label_control }}
                  </div>
                  <div v-else>
                    {{ translations.label_contrast_b }}
                  </div>
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  solo
                  :label="translations.label_name"
                  outlined
                  :rules="validation(translations.field_required)"
                  v-model="form.secondaryContrast.name"
                  background-color="white"
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0">
                <v-autocomplete
                  solo
                  :label="translations.label_select_irrigation_unit"
                  outlined
                  v-model="tempCropZoneSecondary"
                  :search-input.sync="searchSecondary"
                  item-text="cropZoneName"
                  hide-no-data
                  :items="secondaryContrastCropZones"
                  :loading="isLoadingSecondaryCropZones"
                  background-color="white"
                  dense
                  @change="addSecondaryCropZone"
                  return-object
                  ref="secondaryCrop"
                  :rules="[secondaryValidation]"
                  :disabled="
                    isUpdatingProject && statusProjectToUpdate != 'NEW'
                  "
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="statusProjectToUpdate == 'NEW'">
                <v-chip
                  close
                  @click:close="removeCropZoneB(index)"
                  v-for="(area, index) of form.secondaryContrast.cropZones"
                  :key="index"
                >
                  <v-icon left color="primary"> mdi-sprout </v-icon>
                  {{ area.cropZoneName }}
                </v-chip>
              </v-col>
              <v-col v-else>
                <v-chip
                  v-for="(area, index) of form.secondaryContrast.cropZones"
                  :key="index"
                >
                  <v-icon left color="primary"> mdi-sprout </v-icon>
                  {{ area.cropZoneName }}
                </v-chip>
              </v-col>
            </v-row>
          </div>
          <v-row>
            <v-col class="py-0">
              <v-autocomplete
                solo
                :label="translations.label_select_crop"
                outlined
                :rules="validation(translations.field_required)"
                v-model="form.crop"
                :items="crop_items"
                background-color="white"
                hide-no-data
                dense
                return-object
                :disabled="isUpdatingProject && statusProjectToUpdate != 'NEW'"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row v-if="form.projectType.value != 'PRODUCT_SETUP'">
            <v-col class="py-0">
              <v-autocomplete
                solo
                :label="translations.label_add_phenological_stage"
                outlined
                :rules="validation(translations.field_required)"
                v-model="form.phenologicalStage"
                :items="phenologicalStages"
                background-color="white"
                dense
                return-object
                :disabled="isUpdatingProject && statusProjectToUpdate != 'NEW'"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row v-if="form.projectType.value == 'PRODUCT_SETUP'">
            <v-col>
              <v-btn color="primary" small @click="showNewProductModal = true">
                <v-icon>mdi-plus</v-icon>
                {{ translations.label_add_product }}
              </v-btn>
            </v-col>
            <v-col xl="12">
              <v-chip
                close
                @click:close="removeProduct(index)"
                v-for="(product, index) of form.products"
                :key="index"
              >
                <v-icon color="primary">mdi-sprout</v-icon>
                {{ product.name }} - {{ product.doses }}
                {{ getProductType(product.type) }}
              </v-chip>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
    <NewProductModal
      v-if="showNewProductModal"
      v-model="showNewProductModal"
      @newProduct="addProduct"
    />
  </v-container>
</template>
<script>
//VUEX
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
// Validations
import {
  requiredValidation,
  requiredFValidation,
} from "@/helpers/validations.js";
//modals
import NewProductModal from "@/components/projects/modals/NewProductModal.vue";
export default {
  components: {
    NewProductModal,
  },
  data: () => ({
    searchMain: null,
    searchSecondary: null,
    isLoading: false,
    organizationId: null,
    form: {
      name: null,
      projectType: null,
      description: null,
      mainContrast: {
        name: "",
        cropZones: [],
      },
      secondaryContrast: {
        name: "",
        cropZones: [],
      },
      crop: null,
      phenologicalStage: null,
      client: null,
      isContrast: true,
      size: 0,
      variant: null,
      products: [],
    },
    projectTypes: [
      {
        text: "MISS setup",
        value: "MISS_SETUP",
      },
      {
        text: "MISS test",
        value: "MISS_TEST",
      },
      {
        text: "MISS discovery",
        value: "MISS_DISCOVERY",
      },
      {
        text: "Product setup",
        value: "PRODUCT_SETUP",
      },
    ],
    phenologicalStages: [],
    miss_test_variants: [],
    mis_test_variant_setup: [],
    crop_items: [],
    tempCropZoneMain: null,
    tempCropZoneSecondary: null,
    mainContrastCropZones: [],
    secondaryContrastCropZones: [],
    isLoadingMainCropZones: false,
    isLoadingSecondaryCropZones: false,
    isUpdatingProject: false,
    statusProjectToUpdate: "NEW",
    showNewProductModal: false,
  }),
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    ...mapState("areasList", ["crops"]),
  },
  created() {
    this.miss_test_variants = [
      {
        text: this.translations.miss_test_variants["CONTRAST"],
        value: "CONTRAST",
      },
      {
        text: this.translations.miss_test_variants["UNCONTRASTED"],
        value: "UNCONTRASTED",
      },
      {
        text: this.translations.miss_test_variants["RASTER"],
        value: "RASTER",
      },
    ];
    this.mis_test_variant_setup = [
      {
        text: this.translations.miss_test_variants_setup["CONTRAST"],
        value: "CONTRAST",
      },
      {
        text: this.translations.miss_test_variants_setup["UNCONTRASTED"],
        value: "UNCONTRASTED",
      },
    ];
    this.phenologicalStages = [
      {
        text: this.translations.phenologicalStages["Transplanting"],
        value: "Transplanting",
      },
      {
        text: this.translations.phenologicalStages["Vegetative growth"],
        value: "Vegetative growth",
      },
      {
        text: this.translations.phenologicalStages["Bloom"],
        value: "Bloom",
      },
      {
        text: this.translations.phenologicalStages["Harvest"],
        value: "Harvest",
      },
      {
        text: this.translations.phenologicalStages["Pre-planting"],
        value: "Pre-planting",
      },
      {
        text: this.translations.phenologicalStages["Sowing"],
        value: "Sowing",
      },
      {
        text: this.translations.phenologicalStages["Sprout"],
        value: "Sprout",
      },
      {
        text: this.translations.phenologicalStages["Tuberization"],
        value: "Tuberization",
      },
      {
        text: this.translations.phenologicalStages["Tuber filling"],
        value: "Tuber filling",
      },
      {
        text: this.translations.phenologicalStages["Foliage development"],
        value: "Foliage development",
      },
      {
        text: this.translations.phenologicalStages["Foliar expansion"],
        value: "Foliar expansion",
      },
      {
        text: this.translations.phenologicalStages["First leaf"],
        value: "First leaf",
      },
      {
        text: this.translations.phenologicalStages["Third leaf"],
        value: "Third leaf",
      },
      {
        text: this.translations.phenologicalStages["Fifth leaf"],
        value: "Fifth leaf",
      },
      {
        text: this.translations.phenologicalStages["Start of bulbing"],
        value: "Start of bulbing",
      },
      {
        text: this.translations.phenologicalStages["Bulb growth"],
        value: "Bulb growth",
      },
      {
        text: this.translations.phenologicalStages["Fruit maturity"],
        value: "Fruit maturity",
      },
      {
        text: this.translations.phenologicalStages["Sprouting"],
        value: "Sprouting",
      },
    ];
  },
  async mounted() {
    this.SET_APPBAR_OPTIONS({
      leftButton: "back-arrow",
      funcLeftButton: this.goBack,
      rightButton: "save",
      funcRightButton: this.saveProject,
    });

    let user = JSON.parse(localStorage.getItem("user"));
    if (user.role == "ORG_USER" || user.role == "ORG_USER_ADMIN") {
      if (user.role == "ORG_USER_ADMIN") {
        this.organizationId = localStorage.getItem("organizationId");
      } else {
        this.organizationId = localStorage.getItem("organizationId");
      }
    } else {
      this.organizationId = localStorage.getItem("clientId");
    }
    this.setCropItems();
    if (this.$route.params.projectId) {
      this.isUpdatingProject = true;
      await this.getProject(this.$route.params.projectId);
    }
  },
  methods: {
    ...mapMutations(["SET_APPBAR_OPTIONS", "SET_LOADER"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapActions("areasList", ["searchCropZone"]),
    ...mapActions("project", ["create", "getById", "update"]),
    goBack() {
      this.$router.back();
    },
    async saveProject() {
      if (this.$route.params.projectId) {
        //update current project
        await this.updateProject();
      } else {
        //create new project
        await this.createProject();
      }
    },
    async createProject() {
      let validations = true;
      console.log(this.form.projectType);
      // if (
      //   this.form.projectType &&
      //   this.form.projectType.value == "PRODUCT_SETUP" &&
      //   this.form.products.length == 0
      // ) {
      //   validations = false;
      //   this.SET_ALERT_TYPE({
      //     visible: true,
      //     type: "info",
      //     text: "Añade al menos un producto",
      //     timeout: 4000,
      //   });
      // }

      if (!this.$refs.form.validate()) {
        validations = false;
      }

      if (validations) {
        try {
          this.SET_LOADER(true);
          let payload = {
            name: this.form.name,
            projectType: this.form.projectType.value,
            description: this.form.description,
            mainContrast: this.form.mainContrast,
            secondaryContrast: this.form.secondaryContrast,
            crop: this.form.crop.value,
            phenologicalStage: this.form.phenologicalStage
              ? this.form.phenologicalStage.value
              : null,
            isContrast: this.form.isContrast,
            client: this.organizationId,
            size: this.form.size,
            variant: this.form.variant ? this.form.variant.value : null,
            products: this.form.products,
          };
          let response = await this.create(payload);
          if (!response || response.error) throw response;
          this.SET_LOADER(false);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: this.translations.label_project_created,
            timeout: 4000,
          });
          this.goBack();
        } catch (e) {
          console.log(e);
          this.SET_LOADER(false);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: this.translations.advice_error,
            timeout: 4000,
          });
        }
      }
    },
    async updateProject() {
      let validations = true;
      // if (
      //   this.form.projectType &&
      //   this.form.projectType.value == "PRODUCT_SETUP" &&
      //   this.form.products.length == 0
      // ) {
      //   validations = false;
      //   this.SET_ALERT_TYPE({
      //     visible: true,
      //     type: "info",
      //     text: "Añade al menos un producto",
      //     timeout: 4000,
      //   });
      // }

      if (!this.$refs.form.validate()) {
        validations = false;
      }
      if (validations) {
        try {
          this.SET_LOADER(true);
          let payload = {
            body: {
              name: this.form.name,
              projectType: this.form.projectType.value,
              description: this.form.description,
              mainContrast: this.form.mainContrast,
              secondaryContrast: this.form.secondaryContrast,
              crop: this.form.crop.value,
              phenologicalStage: this.form.phenologicalStage
                ? this.form.phenologicalStage.value
                : null,
              isContrast: this.form.isContrast,
              size: this.form.size,
              variant: this.form.variant.value,
              products: this.form.products,
            },
            query: {
              projectId: this.$route.params.projectId,
            },
          };
          let response = await this.update(payload);
          if (!response || response.error) throw response;
          this.SET_LOADER(false);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: this.translations.label_project_updated,
            timeout: 4000,
          });
          this.goBack();
        } catch (e) {
          console.log(e);
          this.SET_LOADER(false);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: this.translations.advice_error,
            timeout: 4000,
          });
        }
      }
    },
    async getProject(projectId) {
      try {
        let payload = {
          projectId: projectId,
        };
        let response = await this.getById(payload);
        if (!response || response.error) throw response;
        this.mapProject(response.project);
      } catch (e) {
        console.log(e);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: this.translations.advice_error,
          timeout: 4000,
        });
      }
    },
    mapProject(project) {
      this.statusProjectToUpdate = project.status;
      this.form.name = project.name;
      this.form.projectType = this.projectTypes.find(
        (element) => element.value == project.projectType
      );
      this.form.description = project.description;
      this.form.mainContrast = project.mainContrast;
      this.form.secondaryContrast = project.secondaryContrast;
      this.form.crop = this.crop_items.find(
        (element) => element.value == project.crop
      );
      this.form.phenologicalStage = this.phenologicalStages.find(
        (element) => element.value == project.phenologicalStage
      );
      this.form.isContrast = project.isContrast;
      this.form.size = project.size;
      if (project.projectType == "PRODUCT_SETUP") {
        this.form.variant = this.mis_test_variant_setup.find(
          (element) => element.value == project.variant
        );
      } else {
        this.form.variant = this.miss_test_variants.find(
          (element) => element.value == project.variant
        );
      }
      this.form.products = project.products;
    },
    removeCropZoneA(index) {
      let item = this.form.mainContrast.cropZones[index];
      this.form.size += parseFloat(item.cropZoneSize);
      this.form.mainContrast.cropZones.splice(index, 1);
    },
    removeCropZoneB(index) {
      let item = this.form.secondaryContrast.cropZones[index];
      this.form.size += parseFloat(item.cropZoneSize);
      this.form.secondaryContrast.cropZones.splice(index, 1);
    },
    removeProduct(index) {
      this.form.products.splice(index, 1);
    },
    setCropItems() {
      let cropsArray = Object.entries(this.translations.crop_name_list);
      for (let crop of cropsArray) {
        this.crop_items.push({
          text: crop[1],
          value: crop[0],
        });
      }
    },
    validation(value) {
      return requiredValidation(value);
    },
    validationF(value) {
      return requiredFValidation(value);
    },
    mainValidation() {
      return (
        this.form.mainContrast.cropZones.length > 0 ||
        this.translations.label_add_at_least_one_item
      );
    },
    secondaryValidation() {
      return (
        this.form.secondaryContrast.cropZones.length > 0 ||
        this.translations.label_add_at_least_one_item
      );
    },
    addMainCropZone() {
      if (this.tempCropZoneMain) {
        let exist = this.form.mainContrast.cropZones.find(
          (element) =>
            element.cropZoneName == this.tempCropZoneMain.cropZoneName
        );
        if (!exist && typeof this.tempCropZoneMain === "object") {
          this.form.mainContrast.cropZones.push({ ...this.tempCropZoneMain });
          this.form.size += parseFloat(this.tempCropZoneMain.cropZoneSize);
          this.tempCropZoneMain = null;
          this.searchMain = null;
          this.$refs["mainCrop"].reset();
        } else {
          this.tempCropZoneMain = null;
          this.searchMain = null;
          this.$refs["mainCrop"].reset();
        }
      }
    },
    addSecondaryCropZone() {
      if (this.tempCropZoneSecondary) {
        let exist = this.form.secondaryContrast.cropZones.find(
          (element) =>
            element.cropZoneName == this.tempCropZoneSecondary.cropZoneName
        );
        if (!exist && typeof this.tempCropZoneSecondary === "object") {
          this.form.secondaryContrast.cropZones.push({
            ...this.tempCropZoneSecondary,
          });
          this.form.size += parseFloat(this.tempCropZoneSecondary.cropZoneSize);
          this.tempCropZoneSecondary = null;
          this.searchSecondary = null;
          this.$refs["secondaryCrop"].reset();
        } else {
          this.tempCropZoneSecondary = null;
          this.searchSecondary = null;
          this.$refs["secondaryCrop"].reset();
        }
      }
    },
    resetData() {
      this.form.isContrast = true;
    },
    changeVariant() {
      console.log(this.form.variant);
      if (this.form.variant.value == "CONTRAST") {
        this.form.isContrast = true;
      } else {
        this.form.isContrast = false;
      }
    },
    getProductType(value) {
      if (value == "LIQUID") {
        return "L/Ha";
      } else {
        return "Kg/Ha";
      }
    },
    addProduct(product) {
      this.form.products.push(product);
      this.showNewProductModal = false;
    },
  },
  watch: {
    async searchMain(value) {
      if (value) {
        try {
          this.isLoadingMainCropZones = true;
          let payload = {
            clientId: this.organizationId,
            search: value,
            page: 0,
          };
          let response = await this.searchCropZone(payload);
          if (!response || response.error) throw response;
          this.mainContrastCropZones = response.cropZones;
        } catch (e) {
          console.log(e);
        }
        this.isLoadingMainCropZones = false;
      }
    },
    async searchSecondary(value) {
      if (value) {
        try {
          this.isLoadingSecondaryCropZones = true;
          let payload = {
            clientId: this.organizationId,
            search: value,
            page: 0,
          };
          let response = await this.searchCropZone(payload);
          if (!response || response.error) throw response;
          this.secondaryContrastCropZones = response.cropZones;
        } catch (e) {
          console.log(e);
        }
        this.isLoadingSecondaryCropZones = false;
      }
    },
    // tempCropZoneMain(value) {
    //   if (value) {
    //     let exist = this.form.mainContrast.cropZones.find(
    //       (element) => element.cropZoneName == value.cropZoneName
    //     );
    //     if (!exist) {
    //       this.form.mainContrast.cropZones.push(value);
    //       this.tempCropZoneMain = null;
    //       this.searchMain = null;
    //     }
    //   }
    // },
    tempCropZoneSecondary(value) {
      if (value) {
        let exist = this.form.secondaryContrast.cropZones.find(
          (element) => element.cropZoneName == value.cropZoneName
        );
        if (!exist) {
          this.form.secondaryContrast.cropZones.push(value);
          this.tempCropZoneSecondary = null;
          this.searchSecondary = null;
        }
      }
    },
    "form.projectType"(value) {
      //this.form.variant = null;
      // this.form.isContrast = false;
      // this.products = [];
    },
  },
};
</script>
